import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { SignoGerenciadora } from './gerencias-interface/gerencias-interface';
import { SignoGerenciasService } from './gerencias-service/gerencias.service';
import { GuiMsjService } from 'src/app/services/shared/gui-msj.service';
import { PerfilesService } from '@services/perfiles/perfiles.service';
import { AuthService } from '@services/auth/auth.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-gerencias-listado',
  templateUrl: './gerencias-listado.component.html',
  styleUrls: ['./gerencias-listado.component.scss']
})
export class GerenciasListadoComponent implements OnInit {
  @ViewChild('previousRoute') previousRouteLink: ElementRef;

  /* Data Table*/
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = ['nombre', 'activa', '_id'];
  dataSource: MatTableDataSource<SignoGerenciadora>;
  /* Fin Data Table*/

  flagLoaded: boolean = false;
  keyPerfil: string = '';
  
  hasData = (index: number, row: SignoGerenciadora) => !!row;
  noDataFilter = () => this.dataSource.data.length === 0;

  constructor(
    private router: Router,
    private signoGerenciasService: SignoGerenciasService,
    private guiMsjService: GuiMsjService,
    private authService: AuthService,
    private perfilesService: PerfilesService,
  ) {
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit(): void {
    this.getPerfil().then(() => {
      this.perfilesService.allowedByUserLogon(this.router.url, this.previousRoute, this.keyPerfil);
    });
    this.loadDataPage();
  }

  async ngAfterViewInit() {
    await this.loadDataPage();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.setFilterPredicate();
  }

  get previousRoute() {
    const previousRoute = this.previousRouteLink.nativeElement.getAttribute('href');
    return previousRoute;
  }

  async getPerfil() {
    try {
      const user = await this.authService.getUserLogon();
      if (user) {
        const { key } = user?.perfil;
        this.keyPerfil = key;
      }
    } catch (error) {
      console.log('ABM - Error al obtener el perfil del usuario', error);
      return '';
    }
  }

  async loadDataTable() {
    try {
      const gerencias = await this.signoGerenciasService.getGerencias();
      
      this.dataSource = new MatTableDataSource(gerencias);
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.flagLoaded = true;
      
    } catch (error) {
      console.error("Error al cargar el listado de gerenciadoras", error);
      this.flagLoaded = true;
      throw error;
    }
  }

  async loadDataPage() {
    await this.loadDataTable();
  }

  async verGerencia(_id: string) {
    await this.guiMsjService.msjFormSubmit('Espere');
    Swal.showLoading();
    const gerencia: SignoGerenciadora = await this.signoGerenciasService.getGerenciaById(_id);
    if (gerencia != undefined) {
      this.router.navigateByUrl('/gerenciadoras-modificacion');
      this.signoGerenciasService.setGerenciaSeleccionada(gerencia);
      Swal.close();
    } else {
      Swal.close();
    }
  }

  setFilterPredicate() {
    this.dataSource.filterPredicate = (data: SignoGerenciadora, filter: string): boolean => {
      const searchText = filter.trim().toLowerCase();
      return (data.nombre?.toLowerCase() || '').includes(searchText);
    };
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  async toggleActiva(element: SignoGerenciadora, event: Event) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const originalValue = element.activa;
    
    try {
      await this.guiMsjService.msjFormSubmit('Guardando');
      
      const updateData: SignoGerenciadora = {
        _id: element._id,
        nombre: element.nombre,
        activa: isChecked
      };

      await this.signoGerenciasService.updateGerencia(element._id, updateData);
      
      element.activa = isChecked;
      this.dataSource.data = [...this.dataSource.data];
      await this.guiMsjService.msjFormSubmit('DatosGuardados');

    } catch (error) {
      console.error('Error al actualizar:', error);
      (event.target as HTMLInputElement).checked = originalValue;
      element.activa = originalValue;
      await this.guiMsjService.msjFormSubmit('ErrorGuardandoDatos');
    }
  }
}